//app
export const APPLICATION_INIT = 'APPLICATION_INIT';

//config
export const CONFIG_FETCH = 'CONFIG_FETCH';
export const CONFIG_FETCH_SUCCESS = 'CONFIG_FETCH_SUCCESS';
export const CONFIG_FETCH_ERROR = 'CONFIG_FETCH_ERROR';
export const CONFIG_UPDATE_BY_KEY = 'CONFIG_UPDATE_BY_KEY';

//dns records
export const DNS_RECORD_CLEAR_ALL = 'DNS_RECORD_CLEAR_ALL';

export const DNS_RECORD_CREATE = 'DNS_RECORD_CREATE';
export const DNS_RECORD_CREATE_SUCCESS = 'DNS_RECORD_CREATE_SUCCESS';
export const DNS_RECORD_CREATE_ERROR = 'DNS_RECORD_CREATE_ERROR';

export const DNS_RECORD_FETCH_LIST = 'DNS_RECORD_FETCH_LIST';
export const DNS_RECORD_FETCH_LIST_SUCCESS = 'DNS_RECORD_FETCH_LIST_SUCCESS';
export const DNS_RECORD_FETCH_LIST_ERROR = 'DNS_RECORD_FETCH_LIST_ERROR';

export const DNS_RECORD_UPDATE = 'DNS_RECORD_UPDATE';
export const DNS_RECORD_UPDATE_SUCCESS = 'DNS_RECORD_UPDATE_SUCCESS';
export const DNS_RECORD_UPDATE_ERROR = 'DNS_RECORD_UPDATE_ERROR';

//intl
export const INTL_FETCH_TRANSLATIONS = 'INTL_FETCH_TRANSLATIONS';
export const INTL_FETCH_TRANSLATIONS_SUCCESS = 'INTL_FETCH_TRANSLATIONS_SUCCESS';
export const INTL_FETCH_TRANSLATIONS_ERROR = 'INTL_FETCH_TRANSLATIONS_ERROR';

//notifications
export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';
export const NOTIFICATION_REMOVE = 'NOTIFICATION_REMOVE';

//plugins
export const PLUGIN_SETTINGS_FETCH = 'PLUGIN_SETTINGS_FETCH';
export const PLUGIN_SETTINGS_FETCH_SUCCESS = 'PLUGIN_SETTINGS_FETCH_SUCCESS';
export const PLUGIN_SETTINGS_FETCH_ERROR = 'PLUGIN_SETTINGS_FETCH_ERROR';

export const PLUGIN_SETTING_UPDATE = 'PLUGIN_SETTING_UPDATE';
export const PLUGIN_SETTING_UPDATE_SUCCESS = 'PLUGIN_SETTING_UPDATE_SUCCESS';
export const PLUGIN_SETTING_UPDATE_ERROR = 'PLUGIN_SETTING_UPDATE_ERROR';

//user
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_ERROR = 'USER_LOGIN_ERROR';
export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_SIGNUP = 'USER_SIGNUP';
export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS';
export const USER_SIGNUP_ERROR = 'USER_SIGNUP_ERROR';

//zone activation check
export const ZONE_ACTIVATION_CHECK = 'ZONE_ACTIVATION_CHECK';
export const ZONE_ACTIVATION_CHECK_SUCCESS = 'ZONE_ACTIVATION_CHECK_SUCCESS';
export const ZONE_ACTIVATION_CHECK_ERROR = 'ZONE_ACTIVATION_CHECK_ERROR';

//zone analytics
export const ZONE_FETCH_ANALYTICS = 'ZONE_FETCH_ANALYTICS';
export const ZONE_FETCH_ANALYTICS_SUCCESS = 'ZONE_FETCH_ANALYTICS_SUCCESS';
export const ZONE_FETCH_ANALYTICS_ERROR = 'ZONE_FETCH_ANALYTICS_ERROR';

//zone settings
export const ZONE_FETCH_SETTINGS = 'ZONE_FETCH_SETTINGS';
export const ZONE_FETCH_SETTINGS_SUCCESS = 'ZONE_FETCH_SETTINGS_SUCCESS';
export const ZONE_FETCH_SETTINGS_ERROR = 'ZONE_FETCH_SETTINGS_ERROR';

export const ZONE_PURGE_CACHE = 'ZONE_PURGE_CACHE';
export const ZONE_PURGE_CACHE_SUCCESS = 'ZONE_PURGE_CACHE_SUCCESS';
export const ZONE_PURGE_CACHE_ERROR = 'ZONE_PURGE_CACHE_ERROR';

export const ZONE_UPDATE_SETTING = 'ZONE_UPDATE_SETTING';
export const ZONE_UPDATE_SETTING_SUCCESS = 'ZONE_UPDATE_SETTING_SUCCESS';
export const ZONE_UPDATE_SETTING_ERROR = 'ZONE_UPDATE_SETTING_ERROR';

//zone scan
export const ZONE_FETCH_SCAN = 'ZONE_FETCH_SCAN';
export const ZONE_FETCH_SCAN_SUCCESS = 'ZONE_FETCH_SCAN_SUCCESS';
export const ZONE_FETCH_SCAN_ERROR = 'ZONE_FETCH_SCAN_ERROR';

export const ZONE_UPDATE_SCAN = 'ZONE_UPDATE_SCAN';
export const ZONE_UPDATE_SCAN_SUCCESS = 'ZONE_UPDATE_SCAN_SUCCESS';
export const ZONE_UPDATE_SCAN_ERROR = 'ZONE_UPDATE_SCAN_ERROR';

//zones
export const ZONES_DELETE_ZONE = 'ZONES_DELETE_ZONE';
export const ZONES_DELETE_ZONE_SUCCESS = 'ZONES_DELETE_ZONE_SUCCESS';
export const ZONES_DELETE_ZONE_ERROR = 'ZONES_DELETE_ZONE_ERROR';

export const ZONES_FETCH = 'ZONES_FETCH';
export const ZONES_FETCH_SUCCESS = 'ZONES_FETCH_SUCCESS';
export const ZONES_FETCH_ERROR = 'ZONES_FETCH_ERROR';

export const ZONES_SET_ACTIVE_ZONE = 'ZONE_SET_ACTIVE_ZONE';

export const ZONES_PROVISION_CNAME = 'ZONES_PROVISION_CNAME';
export const ZONES_PROVISION_CNAME_SUCCESS = 'ZONES_PROVISION_CNAME_SUCCESS';
export const ZONES_PROVISION_CNAME_ERROR = 'ZONES_PROVISION_CNAME_ERROR';

export const ZONES_PROVISION_FULL = 'ZONES_PROVISION_FULL_ZONE';
export const ZONES_PROVISION_FULL_SUCCESS = 'ZONES_PROVISION_FULL_ZONE_SUCCESS';
export const ZONES_PROVISION_FULL_ERROR = 'ZONES_PROVISION_FULL_ZONE_ERROR';

//railgun
export const ZONE_RAILGUNS_FETCH_ALL = 'ZONES_RAILGUNS_FETCH_ALL';
export const ZONE_RAILGUNS_FETCH_ALL_SUCCESS = 'ZONES_RAILGUNS_FETCH_ALL_SUCCESS';
export const ZONE_RAILGUNS_FETCH_ALL_ERROR = 'ZONES_RAILGUNS_FETCH_ALL_ERROR';

export const ZONE_RAILGUNS_CONNECTION_UPDATE = 'ZONES_RAILGUNS_CONNECTION_UPDATE';
export const ZONE_RAILGUNS_CONNECTION_UPDATE_SUCCESSS = 'ZONES_RAILGUNS_CONNECTION_UPDATE__SUCCESS';
export const ZONE_RAILGUNS_CONNECTION_UPDATE_ERROR = 'ZONES_RAILGUNS_CONNECTION_UPDATE_ERROR';